<template>
	<!-- <div @scroll="onScroll"></div> -->
	<!-- <div class="scroll-section">
		<div class="scroll bounce-1" id="scroll">
			<img src="~images/scroll-arrow.svg" alt="">
		</div>
	</div> -->

<!-- <transition
appear
@before-enter="beforeEnter"
@enter="enter"
> -->
	<div id="hero">
		<div class="hero" >
			<div class="px-4 py-5 my-5 text-center hero_content">
				<img class="hero_logo" src="~images/logo/NYI-Logo-White.svg" alt="">

				<div class="mx-auto">
					<p class="text-content mb-4">
						Thank you for being part of the best fanbase in the National Hockey League! Season Ticket Members are at the center of every amazing moment both on and off the ice, and we look forward to welcoming you to the Member family.

					</p>
					<p class="text-content mb-4">
						We are committed to making the 2023-24 Member experience better than ever by bringing back the most popular benefits along with brand new customizable and exclusive experiences only for Season Ticket Members. Please read through the full site below to explore everything we have in store for Members.

					</p>


				</div>
			</div>


		</div>
	</div>
	<!-- </transition> -->
</template>

<script>

export default {
	name: "Hero",

};

</script>
<style lang="scss" scoped>

.hero {
	background-image: url("~images/hero/bg-home.jpg");
	background-position: center;
	background-size: cover;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	flex-wrap: nowrap;
	align-items: center;
	justify-content:center;
	position:relative;
	height: 100vh;
	.member_since{
		color:theme-var($--ch-theme-on-primary);
		font-family: "GeogrotesqueSharp-Md";
		text-transform:uppercase;
		font-size: 26px;
		letter-spacing: 0;
		text-align: center;
		line-height: 110%;
		font-weight: 500;
		margin :20px 0px 40px 0px;
		@include media-breakpoint-down(sm) {
			font-size: 17px;
		}
	}
	&_logo{
		height:90px;
		width:auto;
		margin-bottom:20px;
		@include media-breakpoint-down(sm) {
			margin-bottom:50px;
		}
	}

	&_content {
		// width: 100%;
		margin-bottom:15px !important;
		padding-bottom:15px !important;
		position:absolute;
		bottom: 20px;
		@include media-breakpoint-down(sm) {

		}
		h1 {
			font-family: "GeogrotesqueSharp-ExpBd";
			font-size: 70px;
			letter-spacing: 0;
			text-align: center;
			font-weight: 700;
			line-height: 90%;
			color: theme-var($--ch-theme-on-primary);
			text-transform: uppercase;
			margin-bottom:30px;
			@include media-breakpoint-down(sm) {
				font-size: 40px;
			}
			// @media screen and (min-width: 1600px) {
			// 	font-size: 26px;
			// }
		}
		.text-content{
			font-family: GeogrotesqueSharp-Md;
			font-size: 18.5px;
			color: theme-var($--ch-theme-on-primary);
			letter-spacing: 0;
			text-align: center;
			font-weight: 500;
			max-width: 700px;
			display: block;
			margin: 0 auto;
			@include media-breakpoint-down(sm) {
				font-size: 16px;
				max-width: 290px;
				padding-top:10px;
			}
			b{
				font-family: "GeogrotesqueSharp-Bd";
			}
		}

	}
}
@media only screen and (max-width: 1200px) {
	.hero {
		&_logo{
			// margin: 20px auto;
		}
		&_content {

		}

	}
}
@media only screen and (max-width: 900px) {
	.hero {
		&_content {

		}
	}
}
</style>
